"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteUser = exports.associateUserToSystem = exports.editUser = exports.createUser = exports.listAllUsers = exports.ENDPOINT = void 0;
const query_string_1 = __importDefault(require("query-string"));
const api_1 = require("@/services/api");
exports.ENDPOINT = "/users";
function listAllUsers(queryParams) {
    const params = query_string_1.default.stringify({
        pageIndex: queryParams?.pageIndex,
        pageSize: queryParams?.pageSize,
    });
    const url = queryParams
        ? `${exports.ENDPOINT}?${params}&order[username]=${queryParams.orderValue}`
        : exports.ENDPOINT;
    return api_1.axiosInstance
        .get(url)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new Error(`[Get Users Error]: ${error.message}`);
    });
}
exports.listAllUsers = listAllUsers;
function createUser(payload) {
    return api_1.axiosInstance
        .post(exports.ENDPOINT, payload)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new Error(`[Create User Error]: ${error.message}`);
    });
}
exports.createUser = createUser;
function editUser(userId, payload) {
    return api_1.axiosInstance
        .put(`${exports.ENDPOINT}/${userId}`, payload)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new Error(`[Edit User Error]: ${error.message}`);
    });
}
exports.editUser = editUser;
function associateUserToSystem(userId, payload) {
    return api_1.axiosInstance
        .patch(`${exports.ENDPOINT}/${userId}/systems`, payload)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new Error(`[Associate User to System Error]: ${error.message}`);
    });
}
exports.associateUserToSystem = associateUserToSystem;
function deleteUser(userId) {
    return api_1.axiosInstance
        .delete(`${exports.ENDPOINT}/${userId}/`)
        .then((response) => {
        return response.status;
    })
        .catch((error) => {
        throw new Error(`[Delete User]: ${error.message}`);
    });
}
exports.deleteUser = deleteUser;
